import React from 'react';
import {View} from 'react-native';
import CCText from '@/Atoms/CCText';

type EvalBarProps = {
  // Gate rendering entirely (engine off / board not measured yet).
  visible: boolean;
  boardWidth: number;
  // handleStockfishResult's display payload: white-POV display score plus
  // the raw side-to-move score used to position the fill.
  evalResult: {
    score: string;
    rawScore: string | number;
    isMate: boolean;
  } | null;
  flipped: boolean;
};

// The vertical eval bar next to the board, lichess-style: white's share of
// the bar follows the eval clamped to ±8 pawns, mate pins it to 100/0, and
// the numeric score sits on whichever side is winning.
function EvalBar({visible, boardWidth, evalResult, flipped}: EvalBarProps) {
  if (!visible) {
    return null;
  }

  let whitePercentage = 50;
  if (evalResult) {
    const {rawScore, isMate} = evalResult;
    if (isMate) {
      whitePercentage = Number(rawScore) > 0 ? 100 : 0;
    } else {
      const cp = Number(rawScore) || 0;
      const val = cp / 100;
      const clamped = Math.max(-8, Math.min(8, val));
      whitePercentage = ((clamped + 8) / 16) * 100;
    }
  }

  const displayPercentage = flipped ? 100 - whitePercentage : whitePercentage;

  let scoreText = '0.0';
  if (evalResult) {
    scoreText = evalResult.score;
  }

  const whiteIsBetter = whitePercentage > 50;
  const isTextOnWhite = flipped ? !whiteIsBetter : whiteIsBetter;

  return (
    <View
      style={{
        width: 20,
        height: boardWidth,
        backgroundColor: '#262322',
        borderRadius: 4,
        overflow: 'hidden',
        position: 'relative',
        borderWidth: 1,
        borderColor: 'rgba(38,35,34,0.15)',
      }}>
      <View
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: flipped ? undefined : 0,
          top: flipped ? 0 : undefined,
          height: `${displayPercentage}%`,
          backgroundColor: '#FFFFFF',
        }}
      />
      <View
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          top: isTextOnWhite
            ? flipped
              ? 6
              : undefined
            : flipped
            ? undefined
            : 6,
          bottom: isTextOnWhite
            ? flipped
              ? undefined
              : 6
            : flipped
            ? 6
            : undefined,
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <CCText
          fontSize={9}
          fontWeight="bold"
          color={isTextOnWhite ? '#262322' : '#FFFFFF'}
          style={{
            textAlign: 'center',
          }}>
          {scoreText}
        </CCText>
      </View>
    </View>
  );
}

export default EvalBar;
